// Ad frequency helper — how many posts/reels between ads, with a gentle
// "new member" grace period that shows FEWER ads to protect the first experience.
export function adEvery(key, config, user, fallback) {
  const feed = (config?.settings?.algorithms?.feed) || {};
  let every = Math.max(2, Number(feed[key]) || fallback);
  const graceDays = Math.max(0, Number(feed.new_member_grace_days ?? 7));
  const mult = Math.max(1, Number(feed.new_member_ad_multiplier ?? 2));
  if (user?.created_at && graceDays > 0 && mult > 1) {
    const ageDays = (Date.now() - new Date(user.created_at).getTime()) / 86400000;
    if (ageDays >= 0 && ageDays < graceDays) every = Math.round(every * mult);
  }
  return every;
}
